import { AuthService } from '../../features/auth/auth.service'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

@Injectable({
  providedIn: 'root'
})
export class MirrorPoliciesGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    // Proposta de seguro é documento interno: só o acesso owner enxerga.
    if (this.authService.isOwnerAccess()) {
      return true
    }

    this.router.navigate(['/dashboard-inicial'])
    return false
  }
}
